import { clx } from "@src/components/utils/stringUtils";
import { PanelLeftIcon } from "lucide-react";
import React from "react";
import styles from "./PanelToggleButton.module.scss";

interface IPanelToggleButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	onClick: () => void;
	ariaLabel: string;
	className?: string;
}

export const PanelToggleButton: React.FC<IPanelToggleButtonProps> = ({ onClick, ariaLabel, className, ...rest }) => (
	<button {...rest} type="button" className={clx(styles.toggle, className ?? "")} onClick={onClick} aria-label={ariaLabel}>
		<PanelLeftIcon size={18} />
	</button>
);
